import type React from 'react';
import type { IconProps } from 'types/icon';

const Tick: React.FC<IconProps> = ({
  size = '24',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...attributes}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.374 4.95943C12.5693 5.1547 12.5693 5.47128 12.374 5.66654L6.35381 11.6867C6.15855 11.8819 5.84197 11.8819 5.64671 11.6867L2.95988 8.99984C2.76462 8.80457 2.76462 8.48799 2.95988 8.29273C3.15514 8.09747 3.47172 8.09747 3.66699 8.29273L6.00026 10.626L11.6669 4.95943C11.8622 4.76417 12.1788 4.76417 12.374 4.95943Z"
        fill={color}
      />
    </svg>
  );
};

export default Tick;
